module.exports = __webpack_public_path__ + "images/hero-bg2-mobile.png";